import { createSlice } from "@reduxjs/toolkit";

const initialState = localStorage.getItem("activeTile")
  ? JSON.parse(localStorage.getItem("activeTile"))
  : {
      index: 1,
    };

const activeTileSlice=createSlice({
    name:"activeTileSlice",
    initialState,
    reducers:{
        increaseIndex:(state,active)=>{
            state.index=state.index+1;
            localStorage.setItem("activeTile",JSON.stringify(state));
            return state;
        },
        decreaseIndex:(state,action)=>{
            state.index=state.index-1;
            localStorage.setItem("activeTile",JSON.stringify(state));
            return state;
        },
        resetIndex:(state,action)=>{
            state.index=1;
            // localStorage.setItem("activeTile",JSON.stringify(state));
            localStorage.removeItem("activeTile");
            return state;
        }
    }
})
export const {increaseIndex,decreaseIndex,resetIndex}=activeTileSlice.actions;
export default activeTileSlice;